import { RouteObject } from 'react-router';
import { AddUpdate } from '@/const';
import CountryListPage from './pages/country/list';
import CountryUpdatePage from './pages/country/update';
import RegionListPage from './pages/region/list';
import RegionUpdatePage from './pages/region/update';
import CityListPage from './pages/city/list';
import CityUpdatePage from './pages/city/update';
import UnitListPage from './pages/unit/list';
import UnitUpdatePage from './pages/unit/update';
import DivisionListPage from './pages/division/list';
import DivisionUpdatePage from './pages/division/update';

export const routes: RouteObject[] = [
  {
    path: 'localization',
    children: [
      {
        path: 'country',
        element: <CountryListPage appName={'localization'} model={'country'} />,
      },
      {
        path: `country${AddUpdate}`,
        element: (
          <CountryUpdatePage appName={'localization'} model={'country'} />
        ),
      },
      {
        path: 'region',
        element: <RegionListPage appName={'localization'} model={'region'} />,
      },
      {
        path: `region${AddUpdate}`,
        element: <RegionUpdatePage appName={'localization'} model={'region'} />,
      },
      {
        path: 'city',
        element: <CityListPage appName={'localization'} model={'city'} />,
      },
      {
        path: `city${AddUpdate}`,
        element: <CityUpdatePage appName={'localization'} model={'city'} />,
      },
      {
        path: 'unit',
        element: <UnitListPage appName={'localization'} model={'unit'} />,
      },
      {
        path: `unit${AddUpdate}`,
        element: <UnitUpdatePage appName={'localization'} model={'unit'} />,
      },
      {
        path: 'division',
        element: (
          <DivisionListPage appName={'localization'} model={'division'} />
        ),
      },
      {
        path: `division${AddUpdate}`,
        element: (
          <DivisionUpdatePage appName={'localization'} model={'division'} />
        ),
      },
    ],
  },
];
